import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';

import { UsersService } from '@services/api/administracja/user-access/users.service';

@Directive({
  selector: '[isAllowed]',
})
export class IsAllowedDirective {
  constructor(
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionsService: UsersService,
  ) {}

  @Input() set isAllowed(permissionCode: string) {
    this.permissionsService.doesUserHavePermission(permissionCode).subscribe((isAllowed) => {
      if (isAllowed) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
